import {NgModule} from '@angular/core';
import {IonicPageModule} from 'ionic-angular';
import {FingerFlashCardPage} from './finger-flash-card';
import {ComponentsModule} from "../../components/components.module";
import {TranslateModule} from "@ngx-translate/core";

@NgModule({
    declarations: [
        FingerFlashCardPage,
    ],
    imports: [
        TranslateModule,
        ComponentsModule,
        IonicPageModule.forChild(FingerFlashCardPage),
    ],
    entryComponents: [FingerFlashCardPage]
})
export class FingerFlashCardPageModule {
}



// WEBPACK FOOTER //
// ./src/pages/finger-flash-card/finger-flash-card.module.ts